module.exports = __webpack_public_path__ + "img/avatar.17f29af5.jpg";